import React from 'react'
import { Link } from 'gatsby'
import { Button, Box, Heading, Text } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  author: {
    display: `inline-block`,
    color: `primary`
  },
  occupation: {
    mb: 4
  },
  specialty: {
    color: `text`,
    mb: 4
  }
}

export default () => (
  <>
    <Heading variant='h1'>
      DCT  <Text sx={styles.author} style={{ color: "darkorange"}}>Academy</Text>.
    </Heading>
    <Heading variant='h2' sx={styles.occupation}>
Learn to code, Change your Life    </Heading>
    <Heading variant='h3' sx={styles.specialty}>
    Learn to build applications using Javascript, React, Angular, Node, Express & MongoDB.
    </Heading>
    <Box variant='buttons.group'>
      <Button style={{background: "darkorange", color: "black", borderColor:"darkorange"}} as={Link} to='/courses'>
        Courses
      </Button>
      <Button variant='white' as={Link} to='/contact'>
        Contact Us
      </Button>
    </Box>
  </>
)
